import { IUserDetailsDto } from "../interface/dto/user-details.dto";
import { AuthActionType, IAuthAction } from "./auth.actions";

export interface IAuthState {
    isInitialized: boolean;
    isLoading: boolean;
    error?: string;
    user?: IUserDetailsDto;
    isUserLoading: boolean;
}

const initState: IAuthState = {
    isInitialized: false,
    isLoading: false,
    error: undefined,
    isUserLoading: false,
    user: undefined,
};

export const authReducer = (state = initState, action: IAuthAction) => {
    switch (action.type) {
        case AuthActionType.AUTH_INIT:
            return {
                ...state,
                isInitialized: true,
            };
        case AuthActionType.AUTH_LOGIN:
            return {
                ...state,
                isLoading: true,
                error: undefined,
            };
        case AuthActionType.AUTH_LOGIN_ERROR:
            return {
                ...state,
                isLoading: false,
                ...action.payload,
            };
        case AuthActionType.AUTH_LOGIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                ...action.payload,
            };
        case AuthActionType.USER_DETAILS_GET:
            return {
                ...state,
                isUserLoading: true,
                error: undefined,
                user: undefined,
            };
        case AuthActionType.USER_DETAILS_GET_ERROR:
            return {
                ...state,
                error: action.payload.error,
                isUserLoading: false,
                user: undefined,
            };
        case AuthActionType.USER_DETAILS_GET_SUCCESS:
            return {
                ...state,
                user: action.payload,
                isUserLoading: false,
            };
        default:
            return state;
    }
};
